module.exports = __webpack_public_path__ + "static/img/黑底.132306c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/黑底.png
// module id = seX4
// module chunks = 1